import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { AdSlot } from "./Ads";

export const Footer = () => (
  <footer className="mt-32 border-t border-white/5 bg-[#060608]" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 py-20 sm:px-10">
      <AdSlot placement="footer" className="mb-16" />
      <p className="font-serif-d mb-16 text-5xl italic leading-none text-white/10 sm:text-8xl lg:text-9xl" aria-hidden>bestpornvideos</p>
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div className="space-y-4">
          <Logo />
          <p className="max-w-sm text-sm leading-relaxed text-slate-400">
            Conteúdo destinado exclusivamente a maiores de 18 anos. Todas as pessoas retratadas tinham 18 anos ou mais no momento da produção.
          </p>
        </div>
        <div>
          <p className="eyebrow mb-4">Navegar</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/videos" className="hover:text-rose-400" data-testid="footer-videos-link">Vídeos</Link></li>
            <li><Link to="/fotos" className="hover:text-rose-400" data-testid="footer-photos-link">Fotos</Link></li>
            <li><Link to="/em-alta" className="hover:text-rose-400" data-testid="footer-trending-link">Em alta</Link></li>
          </ul>
        </div>
        <div data-testid="legal-footer-links">
          <p className="eyebrow mb-4">Legal</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/legal/termos" className="hover:text-rose-400" data-testid="footer-terms-link">Termos de Uso</Link></li>
            <li><Link to="/legal/privacidade" className="hover:text-rose-400" data-testid="footer-privacy-link">Política de Privacidade</Link></li>
            <li><Link to="/legal/2257" className="hover:text-rose-400" data-testid="footer-2257-link">Aviso Legal 18+ / 2257</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-wrap justify-between gap-4 border-t border-white/5 pt-8 font-mono-d text-xs text-slate-400">
        <span>© 2026 bestpornvideos.com.br</span>
        <span className="text-rose-400">RTA · Restricted To Adults · 18+</span>
      </div>
    </div>
  </footer>
);
